export default "/images/3f9cbc18d27c5a881f6f274d62a70e38.avif";